
import Phaser from 'phaser';
import AImage from './AImage.js';
import ABCyaPhaser from '@abcya/abcya_phaser';

export default class ATextButton extends Phaser.GameObjects.Container
{
    constructor(scene, x, y, upFrame, downFrame, onClick)
    {
        super(scene, x, y);

        this.backImage = ABCyaPhaser.Images.addImage(0, 0, upFrame, this);
        ABCyaPhaser.Container.setContainerInteractive(this, true);

        // this.setInteractive({ useHandCursor: true  });
        this.upFrame = upFrame;
        this.downFrame = downFrame;
        this.onClick = onClick;
        this.isDown = false;
        this.downTime = 0;
        this.originalTint = 0xffffff;
        // this.setOrigin(.5, 0);

        this.onDown = null;
        this.onUp = null;

        this.on('pointerdown', (p) => { this.eh_PointerDown(p); });
        this.on('pointerup', (p) => { this.eh_PointerUp(p); });
        this.on('pointerout', (p) => { this.eh_PointerUp(p); });

        this.soundKey = "click";
        // this.scene.input.on('pointerup', ()=>{this.eh_PointerUp();});
    }

    preUpdate(){}

    set tint(value)
    {
        this.originalTint = value;
        super.tint = value;
    }

    eh_PointerDown(pointer)
    {
        if(!this.input.enabled) return;
        
        this.isDown = true;
        this.downTime = this.scene.time.now;

        this.depressButton();
        this.onPointerDown();
    }

    eh_PointerOut()
    {
        if(!this.input.enabled) return;

        if(this.isDown) this.unpressButton();
        this.isDown = false;
        this.onPointerOut();
    }

    eh_PointerUp(p)
    {
        if(!this.input.enabled || !this.isDown) return;

        this.unpressButton();

        if(this.isDown)
        {
            this.isDown = false;
            let timeDown = this.scene.time.now - this.downTime;
            let distanceTraveled = Phaser.Math.Distance.Between(p.downX, p.downY, p.upX, p.upY);
            if(this.onClick!= null && distanceTraveled < 50)
            {
                this.onClick();
                if(this.scene) this.scene.playSound(this.soundKey);
            }
        }
        this.onPointerUp();
    }

    setEnabled(enabled)
    {
        this.input.enabled = enabled;
        if(!enabled)
        {   
            this.disableInteractive();
            this.tint = 0xaaaaaa;
        }
        else
        {
            this.setInteractive();
            this.tint = 0xffffff;
        }
        return this;
    }

    onPointerDown(){} //OVERRIDE THESE GUYS
    onPointerUp(){}

    depressButton()
    {
        if(!this.input.enabled) return;
        if(this.buttonTween) this.buttonTween.stop();
        if(this.downFrame) this.backImage.setFrame(this.downFrame);
        if(this.onDown) this.onDown();
        this.buttonTween = this.scene.addTween(this, 100, {scaleX: this.scaleX < 0 ? -.9 : .9, scaleY: this.scaleY < 0 ? -.9 : .9}, Phaser.Math.Easing.Sine.Out);
    }
    
    unpressButton()
    {
        if(!this.input.enabled) return;
        if(this.buttonTween) this.buttonTween.stop();
        if(this.upFrame != this.backImage.frame.name) this.backImage.setFrame(this.upFrame);
        if(this.onUp) this.onUp();
        this.buttonTween = this.scene.addTween(this, 1000, {scaleX: this.scaleX < 0 ? -1 : 1, scaleY: this.scaleY < 0 ? -1 : 1}, "Elastic");
    }
}